<template>
  <div :class="className" :style="{height: height,width: width}" />
</template>
<script>

import * as echarts from 'echarts'
require('echarts/theme/macarons')
import resize from '@/mixins/resize'

export default {
  components: {},
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '22rem'
    },
    colorData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getLineData(data, date) {
      
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions()
    },
    setOptions({ expectedData, actualData } = {}) {
      this.chart.setOption({
        title: {
          show: false,
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: {
            color: '#909399',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#FFFFFF'
            }
          },
          backgroundColor: '#FFFFFF'
        },
        toolbox: {
        },
        legend: {
          data: [
            {icon:'circle',name:'市场'}, 
            {icon:'circle',name:'本品牌'}, 
            {icon:'circle',name:'上个季度'}, 
          ],
          left: 'left',
          itemWidth: 10,
          textStyle: {
            color: '#000',
            fontSize: 16
          }
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['拉链重', '拉链不好使', '拉链太难拉了'],
            axisPointer: {
              type: 'shadow'
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#000',
              fontSize: 16
            },
            axisLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            nameLocation:'left',
            nameTextStyle:{
              color: '#000',
              fontSize:14,
              padding:[0,120,-30,0]
            },
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              color: '#000',
              fontSize: 16,
              formatter: '{value}%'
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: '#000'
              },
              textStyle: {
                color: '#000'
              }
            },
            axisTick: {
              show: false,
            },  
            axisLine:{
              show:false
            },
            splitArea : {
              show : false
            },
          },
        ],
        color: ['#234990', '#FFBD00', '#B3B3B3'],
        series: [
          {
            name: '市场',
            type: 'bar',
            barWidth: 18,
            barGap: 0,
            data: [50, 30, 20]
          },
          {
            name: '本品牌',
            type: 'bar',
            barWidth: 18,
            barGap: 0,
            data: [100, 0, 0]
          },
          {
            name: '上个季度',
            type: 'line',
            smooth: false,
            symbolSize: 0,
            data: [0, 0, 0]
          }
        ]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/voc/cmetcontent/components/LineHistChart.vue